import { TextInput } from 'components/Inputs/TextInput';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { IPartnerDiscount } from 'types/Partner';

import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { IconButton, InputAdornment, Stack, Tooltip } from '@mui/material';

import { CategoryInput } from './CategoryInput';

type Props = { index: number; onDeleteClick: () => void } & IPartnerDiscount;

export const DiscountsRow: React.FC<Props> = ({
  index,
  children,
  onDeleteClick,
}) => {
  const getFieldName = (fieldName: string) =>
    `discountsUpdate.${index}.${fieldName}` as any;

  return (
    <Stack spacing={2} sx={{ marginTop: 4 }}>
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <CategoryInput
          name={getFieldName('categories')}
          discountIndex={index}
        />

        <TextInput
          required
          name={getFieldName('discountValue')}
          id="discount"
          label="Desconto"
          type="number"
          fullWidth={false}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          }}
        />

        <Tooltip title="Deletar">
          <IconButton aria-label="Deletar" onClick={onDeleteClick} size="large">
            <DeleteOutlineIcon />
          </IconButton>
        </Tooltip>

        {children}
      </Stack>

      <OtherDiscountInput fieldName={getFieldName('categories')} />
    </Stack>
  );
};

const OtherDiscountInput: React.FC<{ fieldName: string }> = ({ fieldName }) => {
  const { watch, setValue } = useFormContext();
  const name = `${fieldName}.others`;
  const values = watch(name);

  if (!values?.isSelected) {
    return null;
  }

  return (
    <TextInput
      required
      name={`${name}.name`}
      id="discount"
      label="Outros"
      onChange={({ target }) => {
        setValue(`${name}.name`, target.value ?? '');
      }}
      value={values?.name ?? ''}
      placeholder="EX: CONDICIONADOR; PERFUME; CACHECOL"
      sx={{
        pr: 8,
      }}
    />
  );
};
